module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-group', {
    attrs: {
      "label": _vm.field.question,
      "col-class": _vm.field.type == 'textarea' || _vm.field.type == 'images' ? 'col-md-2' : 'col-md-6'
    }
  }, [(_vm.field.type == 'yes/no') ? _c('yes-no-na-buttons', {
    on: {
      "input": _vm.fieldChanged
    },
    model: {
      value: (_vm.field.value),
      callback: function($$v) {
        _vm.field.value = $$v
      },
      expression: "field.value"
    }
  }) : (_vm.field.type == 'images' || _vm.field.type == 'image') ? _c('div', [(!_vm.$root.isOffline) ? _c('image-upload-field', {
    attrs: {
      "api-base": _vm.apiBase,
      "images": _vm.value,
      "multi": true,
      "upload-type": "audit-image"
    },
    on: {
      "imageListChanged": function($event) {
        _vm.imageFieldChange($event)
      }
    }
  }) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v("\n\t\t\tCan't upload images when offline\n\t\t")])], 1) : (_vm.field.type == 'opportunityCounter') ? _c('opportunity-counter-field', {
    on: {
      "change": _vm.fieldChanged
    },
    model: {
      value: (_vm.field.value),
      callback: function($$v) {
        _vm.field.value = $$v
      },
      expression: "field.value"
    }
  }) : (_vm.field.type == 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.value),
      expression: "field.value"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.field.value)
    },
    on: {
      "change": _vm.fieldChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.field.value = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.hasNotes) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.notes),
      expression: "field.notes"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Notes..."
    },
    domProps: {
      "value": (_vm.field.notes)
    },
    on: {
      "change": _vm.fieldChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.field.notes = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.hasObservations) ? _c('div', [_c('label', [_vm._v("Observations")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.observations),
      expression: "field.observations"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Observations"
    },
    domProps: {
      "value": (_vm.field.observations)
    },
    on: {
      "change": _vm.fieldChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.field.observations = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.field.hasRecommendations) ? _c('div', [_c('label', [_vm._v("Recommendation")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field.recommendations),
      expression: "field.recommendations"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Recommendations"
    },
    domProps: {
      "value": (_vm.field.recommendations)
    },
    on: {
      "change": _vm.fieldChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.field.recommendations = $event.target.value
      }
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e3c1c2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AuditField.vue
// module id = 282
// module chunks = 0